import { render } from "./rsm_dashboard.vue?vue&type=template&id=d24db31c&scoped=true&ts=true"
import script from "./rsm_dashboard.vue?vue&type=script&lang=ts"
export * from "./rsm_dashboard.vue?vue&type=script&lang=ts"

import "./rsm_dashboard.vue?vue&type=style&index=0&id=d24db31c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d24db31c"]])

export default __exports__